const internals = { sessions: new WeakMap() };

module.exports = { ensureInterestCatalog, isInterestCatalogReady };

function ensureInterestCatalog(context) {

    const { selectors: { all: selectors }, redux: { hooks: redux }, actions } = context;
    const state = redux.getState();
    const token = selectors.getApiToken?.(state);
    const schoolId = selectors.getCurrentSchoolId?.(state);

    if (!selectors.getIsAuthenticated?.(state) || !token || !schoolId) {
        return Promise.resolve(false);
    }

    const existing = internals.sessions.get(context);

    const catalogPresent = (!selectors.getIsLoadingInterests || !selectors.getIsLoadingInterests(state))
        && (!selectors.getCategories || selectors.getCategories(state)?.length > 0);

    if (existing?.token === token && existing.schoolId === schoolId
        && (!existing.ready || catalogPresent)) {
        return existing.promise;
    }

    const record = { token, schoolId, ready: false };
    const isCurrent = () => selectors.getIsAuthenticated(redux.getState())
        && selectors.getApiToken(redux.getState()) === token
        && selectors.getCurrentSchoolId(redux.getState()) === schoolId;

    // fetchAppEntities also rejects stale session responses before Redux updates.
    record.promise = Promise.resolve().then(async () => {

        if (!isCurrent()) {
            throw new Error('Community changed while loading interests.');
        }

        const response = await redux.dispatch(actions.dataFetching.fetchAppEntities({
            entities: ['interests', 'categories'], schoolId
        }));

        if (!isCurrent()) {
            throw new Error('Community changed while loading interests.');
        }

        const result = response?.payload?.result?.result;

        if (!Array.isArray(result?.interests) || !Array.isArray(result?.categories)) {
            throw new Error('Unable to load interests. Please try again.');
        }

        record.ready = true;
        return true;
    }).catch((error) => {

        if (internals.sessions.get(context) === record) {
            internals.sessions.delete(context);
        }

        throw error;
    });

    internals.sessions.set(context, record);
    return record.promise;
}

function isInterestCatalogReady(context) {

    const record = internals.sessions.get(context);
    const selectors = context.selectors.all;
    const state = context.redux.hooks.getState();

    return !!record?.ready && !!selectors.getIsAuthenticated?.(state)
        && record.token === selectors.getApiToken?.(state)
        && record.schoolId === selectors.getCurrentSchoolId?.(state)
        && (!selectors.getIsLoadingInterests || !selectors.getIsLoadingInterests(state))
        && (!selectors.getCategories || selectors.getCategories(state)?.length > 0);
}
